import Fonts from './shared/Fonts';
import Countdown from './shared/Countdown';
import { Stars } from './shared/Decorations';

export default function BabyShowerAzul({ data, title }) {
  const d = data || {};
  const babyName = d.babyName;
  const parents = d.parents;
  const date = d.date ? new Date(d.date) : null;

  const dateStr = date
    ? date.toLocaleDateString('es-PE', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
      })
    : null;

  const colors = {
    sky: '#a5d8ff',
    blue: '#4a90d9',
    soft: '#e7f3ff',
    cloud: '#ffffff',
    dark: '#2c3e50',
  };

  const font = "'Quicksand', sans-serif";

  return (
    <div
      className="min-h-screen w-full relative overflow-hidden"
      style={{
        background: `linear-gradient(180deg, ${colors.sky} 0%, #d4ecff 30%, #e7f3ff 70%, ${colors.soft} 100%)`,
      }}
    >
      <Fonts for="baby" />

      {/* Nubes decorativas */}
      <div className="absolute inset-0 pointer-events-none">
        <svg viewBox="0 0 400 100" className="absolute top-10 left-0 w-40 opacity-80">
          <ellipse cx="50" cy="70" rx="35" ry="20" fill="white" />
          <ellipse cx="80" cy="60" rx="45" ry="25" fill="white" />
          <ellipse cx="110" cy="70" rx="30" ry="18" fill="white" />
        </svg>
        <svg viewBox="0 0 400 100" className="absolute top-32 right-4 w-32 opacity-70">
          <ellipse cx="50" cy="70" rx="30" ry="18" fill="white" />
          <ellipse cx="80" cy="60" rx="40" ry="22" fill="white" />
        </svg>
        <Stars color="#ffffff" className="absolute bottom-20 left-4 w-40 opacity-60" />
        <Stars color="#ffffff" className="absolute bottom-32 right-4 w-32 opacity-60" />
      </div>

      {/* Hero */}
      <section className="relative px-6 pt-24 pb-16 sm:pt-32 sm:pb-20">
        <div className="max-w-3xl mx-auto text-center relative">
          <div className="text-7xl sm:text-8xl mb-4">👶</div>

          <p
            className="text-xs sm:text-sm tracking-[0.4em] uppercase mb-4"
            style={{ color: colors.blue, fontFamily: font, fontWeight: 600 }}
          >
            Baby Shower
          </p>

          {babyName && (
            <h1
              className="text-5xl sm:text-7xl mb-4"
              style={{ fontFamily: font, fontWeight: 700, color: colors.dark }}
            >
              {babyName}
            </h1>
          )}

          {!babyName && (
            <h1
              className="text-4xl sm:text-6xl mb-4"
              style={{ fontFamily: font, fontWeight: 700, color: colors.dark }}
            >
              {title || 'Un nuevo bebé viene en camino'}
            </h1>
          )}

          {parents && (
            <p
              className="text-lg sm:text-xl mt-4"
              style={{ fontFamily: font, color: colors.dark, opacity: 0.7 }}
            >
              Con {parents}
            </p>
          )}
        </div>
      </section>

      {/* Cuenta regresiva */}
      {date && (
        <section className="px-6 py-10">
          <div
            className="max-w-2xl mx-auto rounded-3xl p-6 sm:p-8 shadow-xl"
            style={{ background: 'white' }}
          >
            <p
              className="text-center text-xs tracking-widest uppercase mb-5"
              style={{ color: colors.blue, fontFamily: font, fontWeight: 700 }}
            >
              Faltan
            </p>
            <Countdown target={date} accent={colors.blue} labelColor={colors.dark} />
          </div>
        </section>
      )}

      {/* Info */}
      <section className="px-6 py-12">
        <div className="max-w-2xl mx-auto space-y-4">
          {dateStr && (
            <div
              className="rounded-2xl p-6 flex items-center gap-5 shadow-md"
              style={{ background: 'white' }}
            >
              <div className="text-4xl">🗓️</div>
              <div>
                <p className="text-xs uppercase tracking-widest mb-1"
                  style={{ color: colors.blue, fontFamily: font, fontWeight: 700 }}>
                  Cuándo
                </p>
                <p className="text-lg font-bold capitalize" style={{ fontFamily: font, color: colors.dark }}>
                  {dateStr}
                </p>
                {d.time && (
                  <p className="text-sm mt-0.5" style={{ fontFamily: font, color: colors.dark, opacity: 0.7 }}>
                    {d.time}
                  </p>
                )}
              </div>
            </div>
          )}

          {d.place && (
            <div
              className="rounded-2xl p-6 flex items-center gap-5 shadow-md"
              style={{ background: 'white' }}
            >
              <div className="text-4xl">🎈</div>
              <div>
                <p className="text-xs uppercase tracking-widest mb-1"
                  style={{ color: colors.blue, fontFamily: font, fontWeight: 700 }}>
                  Dónde
                </p>
                <p className="text-lg font-bold" style={{ fontFamily: font, color: colors.dark }}>
                  {d.place}
                </p>
                {d.address && (
                  <p className="text-sm mt-0.5" style={{ fontFamily: font, color: colors.dark, opacity: 0.7 }}>
                    {d.address}
                  </p>
                )}
              </div>
            </div>
          )}

          {d.description && (
            <div className="text-center py-8">
              <p
                className="text-lg sm:text-xl leading-relaxed"
                style={{ fontFamily: font, color: colors.dark, opacity: 0.85 }}
              >
                {d.description}
              </p>
            </div>
          )}
        </div>
      </section>

      <footer className="pb-10 text-center">
        <p className="text-xs opacity-70" style={{ fontFamily: font, color: colors.dark }}>
          Invitación creada con <b style={{ color: colors.blue }}>Go Fiesta</b>
        </p>
      </footer>
    </div>
  );
}